module.exports = __webpack_public_path__ + "static/img/fefco320_2.ddb722f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco320_2.png
// module id = 71YB
// module chunks = 0